/**
 * Imports Module Configuration
 *
 * Manages bulk data imports (properties, products, etc.).
 * Accessible via Settings → Data Import — admin only.
 * Does not show as a top-level sidebar item.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const importsModule: AppModule = {
    id: 'imports',

    navigation: {
        label: 'Data Import',
        icon: 'upload',
        path: '/imports',
        order: 91,
        moduleKey: 'settings.data_import',

        // Not shown as top-level sidebar item — accessed via Settings
        showInSidebar: false,

        // Admin only

        pages: [],
    },

    routes,
}

export default importsModule
